import { FILTER_CONFIG_NAMES } from './DataConstants';

export const getWalkthroughFilterConfig = ({ filters }: { filters: any }) => {
	return [
		filters[FILTER_CONFIG_NAMES.LOCATION],
		filters[FILTER_CONFIG_NAMES.NOTES_STATUS],
		filters[FILTER_CONFIG_NAMES.CREATED_AT],
		filters[FILTER_CONFIG_NAMES.COMPLETED_AT],
	].filter(Boolean);
};
